/* eslint-disable class-methods-use-this */
import 'whatwg-fetch';
import moment from 'moment';
import { Calendar } from '@fullcalendar/core';
import listPlugin from '@fullcalendar/list';
import dayGridPlugin from '@fullcalendar/daygrid';

/**
 * @community_calendar {module} menu callback endpoints.
 */
const api = {
  events: '/community_calendar/events',
};

const defaults = {
  city: 'Coachella',
};

export default class CommunityCalendar {
  constructor(element, options) {
    this.element = element;
    this.settings = { ...defaults, ...options };
    this.fetchEvents()
      .then(this.createCalendar.bind(this));
  }

  async fetchEvents() {
    const url = `${api.events}?city=${this.city}&date=${this.firstOfLastMonth}`;
    const options = { cache: 'no-cache' };
    const request = new Request(url, options);
    const response = await fetch(request);
    this.events = await response.json();
  }

  createCalendar() {
    this.calendar = new Calendar(this.element, {
      plugins: [
        listPlugin,
        dayGridPlugin,
      ],
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,listWeek,listDay',
      },
      buttonText: {
        listWeek: 'week',
        listDay: 'day',
      },
      defaultView: 'listWeek',
      defaultDate: this.date,
      navLinks: true,
      eventLimit: true,
      editable: false,
      events: this.events,
      eventClick: ({ el, jsEvent }) => {
        jsEvent.preventDefault();
        const link = el.querySelector('a');
        window.open(link.href, '_blank');
      },
      views: {
        dayGridMonth: {
          defaultDate: this.firstOfTheMonth,
        },
      },
    });

    // Render calculator instance.
    this.calendar.render();

    // Add a mutation listener to re-render the calendar.
    // This is needed in cases where the calendar is created within a
    // hidden container.
    const tabPanel = this.element.closest('.views-row.under-tab');
    if (tabPanel) {
      const observer = new MutationObserver((mutationList) => {
        mutationList.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (tabPanel.classList.contains('js-tabs-show')) {
              this.calendar.changeView(this.calendar.optionsManager.computed.defaultView);
            }
          }
        });
      });
      observer.observe(tabPanel, { attributes: true });
    }

    // Add ready state.
    this.element.classList.add('ready');
  }

  get date() {
    return moment().format('YYYY-MM-DD');
  }

  get firstOfLastMonth() {
    return moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
  }

  get city() {
    return this.element.getAttribute('data-city') || this.settings.city;
  }
}
